import { Box } from "@chakra-ui/react";
import { motion, useScroll, useTransform } from "framer-motion";

const MotionBox = motion(Box);

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <MotionBox
      position="fixed"
      top="0"
      left="0"
      right="0"
      height="3px"
      bg="brand.coral"
      transformOrigin="0%"
      zIndex="9999"
      style={{ scaleX }}
    />
  );
}
